"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.BannerFooter = void 0;
require("./BannerFooter.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _ActionGroups = _interopRequireDefault(require("../ActionGroups/ActionGroups"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * BannerFooter component
 *
 * @method
 * @param {BannerFooterProps} props
 * @returns BannerFooter
 */

const BannerFooter = props => {
  const {
    actions,
    externalAction,
    isKnockoutLink,
    style,
    textAlignment,
    types,
    variant
  } = props;
  if (!actions && !externalAction) {
    return null;
  }
  const componentClassName = (0, _classnames.default)('pal-c-BannerFooter', {
    [`pal-c-BannerFooter--${textAlignment}`]: textAlignment
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_ActionGroups.default, {
    actions: actions,
    alignment: textAlignment,
    isKnockoutLink: isKnockoutLink,
    style: style,
    types: types,
    variant: variant
  }));
};

/**
 * Property type definitions
 * @typedef BannerFooterProps
 * @type {object}
 * @property {array} actions - actions object
 * @property {object} externalAction - external action object
 * @property {boolean} isKnockoutLink - knockout color for link
 * @property {string} style - string value that sets the layout the the ActionGroupDefault
 * @property {string} textAlignment - Set the flex justification
 * @property {string} type - string value that sets the style variants of the buttons and links
 */
exports.BannerFooter = BannerFooter;
const propTypes = exports.propTypes = {
  /**
   * Sets the actions (palette only, no business logic)
   */
  actions: _propTypes.default.array,
  /**
   * Set the flex justification
   */
  alignment: _propTypes.default.oneOf(['left', 'right', 'center', 'between', 'around']),
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /** knockout color for link */
  isKnockoutLink: _propTypes.default.bool,
  /**
   * Sets the stylistic version of the actions
   * - **Primary Button/Secondary Button:** Sets the actions to display as the Primary Button and Secondary Button
   * - **Primary Button/Tertiary Button:** Sets the actions to display as the Primary Button and Tertiary Button
   * - **Primary Button/Primary Link:** Sets the actions to display as the Primary Button and Primary Link
   * - **Secondary Button/Primary Link:** Sets the actions to display as the Secondary Button and Primary Link
   *  - **Primary Link/Primary Link:** Sets the actions to display as two Primary Links
   * - **Arrow Link:** Sets the link to a arrow style
   */
  type: _propTypes.default.oneOf(['Primary Button/Secondary Button', 'Primary Button/Tertiary Button', 'Primary Button/Primary Link', 'Secondary Button/Primary Link', 'Primary Link/Primary Link', 'Arrow Link']),
  /**
   * Sets the layout of the actions
   * - **inline:** Sets the actions to display inline
   * - **stacked:** Sets the actions to display as block elements (flex column)
   * - **stackedFullWidth:** Sets the actions to display as block elements and also forces the buttons to the span full width of the parent container in all viewports. Links are centered but do not spand the full width.
   */
  style: _propTypes.default.oneOf(['inline', 'stacked', 'stackedFullWidth'])
};
BannerFooter.propTypes = propTypes;
var _default = exports.default = BannerFooter;